import { Modal, Spin, Table, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  AuditLog,
  AuditResponse,
  AgentPendingReceiptListData,
  getAgentPendingReceiptList,
  PendingReceiptPagedList,
  PendingReceiptPayload,
} from 'api/receipt';
import { LoadingScreen } from 'common/components';
import { useEffect, useState } from 'react';
//import { message } from 'antd';
import { calculateColumnsWidth } from 'api/common';
import { getAuditLog, retry } from 'api/dashboard';
import moment from 'moment';
import DownloadLogs from './DownloadLogs/DownloadLogs';

// let payPagedList: PendingReceiptPagedList;
// let audit: AuditResponse;

type Props = {
  filter: PendingReceiptPayload;
  setOnlyDigitError: (error: boolean) => void;
};
const PendingReceiptList = ({ filter, setOnlyDigitError }: Props) => {
  let payPagedList: PendingReceiptPagedList = {
    data: {
      noOfRecords: 0,
      currentPageIndex: 0,
      data: [],
    },
  };

  let audit: AuditResponse = {
    data: [],
  };

  const [pagedList, setPagedList] = useState(payPagedList);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditLog, setAuditLog] = useState(audit);
  //const isAdmin = sessionStorage.getItem('isAdmin');
  const [_isRetry, setRetry] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<AgentPendingReceiptListData | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);
  //const [_retryRes, setRetryRes] = useState(retryResponse);
  // console.log('_isRetry', _isRetry);

  filter.Username = sessionStorage.getItem('user')?.toString();
  useEffect(() => {
    setIsLoading(false);
    debugger;
    filter.pageNo = 1;
    filter.pageSize = 10;
    // console.log('filter first time hitting the api', filter);

    getAgentPendingReceiptList(filter)
      .then((res) => {
        // console.log('Response first time hitting the api', res);

        setPagedList(res);
        setOnlyDigitError(false);
        //message.success('Success');
        // console.log(res)
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter, _isRetry]);

  const columns: ColumnsType<AgentPendingReceiptListData> = [
    {
      key: 'PaymentRequestID',
      title: 'Payment Request ID',
      dataIndex: 'PaymentRequestID',
      fixed: 'left',
      width: 200,
      className: '',
    },
    {
      key: 'LANumber',
      title: 'Loan Number',
      dataIndex: 'LANumber',
      fixed: 'left',
      width: 200,
    },
    {
      key: 'LoanType',
      title: 'Loan Type',
      dataIndex: 'LoanType',
      width: 200,
    },
    {
      key: 'AccountID',
      title: 'Account Id',
      dataIndex: 'AccountID',
      width: 200,
    },
    {
      key: 'SourceApplicationName',
      title: 'Source Application Name',
      dataIndex: 'SourceApplicationName',
      width: 250,
    },
    {
      key: 'RequestPurpose',
      title: 'Request Purpose',
      dataIndex: 'RequestPurpose',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'Mode',
      title: 'Mode',
      dataIndex: 'Mode',
      width: 200,
    },
    {
      key: 'PAYMENTPURPOSE',
      title: 'Payment Purpose',
      dataIndex: 'PAYMENTPURPOSE',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'merchantId',
      title: 'Merchant ID',
      dataIndex: 'merchantId',
      width: 200,
    },
    {
      key: 'Amount',
      title: 'Total Amount',
      dataIndex: 'Amount',
      width: 200,
    },
    {
      key: 'RequestStatus',
      title: 'Request Status',
      dataIndex: 'RequestStatus',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'new_status',
      title: 'New Status',
      dataIndex: 'new_status',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'paymentRef',
      title: 'Payment Ref',
      dataIndex: 'paymentRef',
      width: 200,
    },
    {
      key: 'RefTransaction',
      title: 'Ref Transaction',
      dataIndex: 'RefTransaction',
      width: 200,
    },
    {
      key: 'razorpay_order_id',
      title: 'Order Id',
      dataIndex: 'razorpay_order_id',
      width: 200,
    },
    {
      key: 'razorpay_payment_id',
      title: 'Payment Id',
      dataIndex: 'razorpay_payment_id',
      width: 200,
    },
    {
      key: 'FundingAccount',
      title: 'Funding Account',
      dataIndex: 'FundingAccount',
      width: 200,
    },
    {
      key: 'BankCode',
      title: 'Bank Code',
      dataIndex: 'BankCode',
      width: 200,
    },
    {
      key: 'Currency',
      title: 'Currency',
      dataIndex: 'Currency',
      width: 200,
    },
    {
      key: 'favourName',
      title: 'Favour Name',
      dataIndex: 'favourName',
      width: 200,
    },
    {
      key: 'PaymentRequestDateTime',
      title: 'Request Date & Time',
      dataIndex: 'PaymentRequestDateTime',
      width: 200,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'PennantReceiptDate',
      title: 'Receipt Date & Time',
      dataIndex: 'PennantReceiptDate',
      width: 200,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'PennantReceiptNo',
      title: 'Pennant Receipt No',
      dataIndex: 'PennantReceiptNo',
      width: 200,
    },
    {
      key: 'AuthCode',
      title: 'AuthCode',
      dataIndex: 'AuthCode',
      width: 200,
    },
    {
      key: 'ByAgent',
      title: 'By Agent',
      dataIndex: 'ByAgent',
      width: 200,
    },
    {
      key: 'remarks',
      title: 'Remark',
      dataIndex: 'remarks',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'PaymentRequestError',
      title: 'Payment Request Status',
      dataIndex: 'PaymentRequestError',
      width: 400,
      ellipsis: true,
    },
    {
      key: 'PennantErrorDesc',
      title: 'Receipt Status',
      dataIndex: 'PennantErrorDesc',
      width: 400,
      ellipsis: true,
    },
    {
      key: 'webhook status',
      title: 'Webhook Status',
      dataIndex: 'webhook status',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'verificationReason',
      title: 'Verification Reason',
      dataIndex: 'verificationReason',
      width: 200,
      ellipsis: true,
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'Action',
      width: 200,
      render: (_text, record) => (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <>
            <button
              className="btn btn-primary btn-sm prime-button"
              onClick={() => showModal(record)}
            >
              View Audit
            </button>
            <button
              className="btn btn-primary btn-sm prime-button"
              onClick={() => handleDownload(record)}
            >
              Download
            </button>
            <button
              className="btn btn-primary btn-sm prime-button"
              onClick={() => retryModal(record)}
            >
              Retry
            </button>
          </>
        </span>
      ),
    },
  ];

  const auditCols: ColumnsType<AuditLog> = [
    {
      key: 'LANumber',
      title: 'Loan Number',
      dataIndex: 'LANumber',
      width: 200,
    },
    {
      key: 'Event',
      title: 'Event',
      dataIndex: 'Event',
      width: 400,
      ellipsis: true,
    },
    {
      key: 'EventDateTime',
      title: 'Event Date',
      dataIndex: 'EventDateTime',
      render: (date: string) => getFullDate(date),
      width: 200,
    },
    {
      key: 'ErrorDescription',
      title: 'Error Description',
      dataIndex: 'ErrorDescription',
      width: 200,
    },
  ];
  let payfilter: PendingReceiptPayload = {};
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const showModal = (record: AgentPendingReceiptListData) => {
    // setIsLoading(false);
    debugger;
    setIsModalLoading(true);
    getAuditLog(record.PaymentRequestID, false).then((res) => {
      setAuditLog(res);
      setIsModalOpen(true);
      // setIsLoading(true);
      setIsModalLoading(false);
    });
  };
  const handleDownloadComplete = () => {
    setIsDownloading(false);
  };

  const handleDownload = (record: AgentPendingReceiptListData) => {
    setSelectedRecord(record);
    setIsDownloading(true);
  };

  const retryModal = (record: AgentPendingReceiptListData) => {
    setIsLoading(true); // Set loading to true initially

    retry(record.PaymentRequestID)
      .then((res) => {
        debugger;
        if (res.responseCode == '200') {
          // Use strict comparison (===) and compare with number
          message.success('Done Successfully!');
          setIsLoading(false);
        } else {
          message.error(res.message);
        }
      })
      .catch((error) => {
        console.error('Error occurred:', error); // Handle any errors that might occur during the retry
        message.error('An error occurred while retrying.');
      })
      .finally(() => {
        setRetry(!_isRetry);
        setIsLoading(true); // Set loading to false after the operation is complete
      });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function getFullDate(date: string) {
    if (!date) return '';
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }

  // const handleChange1 = (_pagination: any, filters: any, sorter: any) => {
  //   setIsLoading(false);
  //   debugger;
  //   if (sorter.hasOwnProperty('column')) {
  //     // params.order = { field: sorter.field, dir: sorter.order };
  //   }

  //   payfilter = filter;
  //   payfilter.pageNo = _pagination.current;
  //   payfilter.pageSize = _pagination.pageSize;
  //   // payfilter.SourceApplicationName = filters.SourceApplicationName?.toString();
  //   payfilter.RequestPurpose = filters.REQUESTPURPOSE?.toString();
  //   payfilter.PAYMENTPURPOSE = filters.PaymentPurpose?.toString();
  //   payfilter.RequestStatus = filters.RequestStatus?.toString();
  //   payfilter.new_status = filters.NEW_STATUS?.toString();
  //   if (isAdmin != 'true') {
  //     payfilter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  //   }
  //   getAgentPendingReceiptList(payfilter).then((res) => {
  //     setPagedList(res);
  //     setIsLoading(true);
  //   });
  // };

  const handleChange = (_pagination: any, _filters: PendingReceiptPayload, sorter: any) => {
    setIsLoading(false);

    debugger;
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }

    payfilter = filter;
    // console.log('FIlter', filter);

    // console.log('pay filter', payfilter);

    payfilter.pageNo = _pagination.current;
    payfilter.pageSize = _pagination.pageSize;

    getAgentPendingReceiptList(payfilter).then((res) => {
      // console.log('Response', res);

      setPagedList(res);
      setIsLoading(true);
    });
  };

  const maxWidthPerCell = 1000;

  const dataTable = calculateColumnsWidth(columns, pagedList.data.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';
  return (
    <>
      <Spin spinning={isModalLoading}>
        <Table
          columns={dataTable.columns}
          dataSource={dataTable.source}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          pagination={{
            pageSize: 10,
            total: pagedList.data.noOfRecords,
            current: pagedList.data.currentPageIndex == 0 ? 1 : pagedList.data.currentPageIndex,
          }}
          onChange={handleChange}
        />
      </Spin>
      ;
      <Modal
        title="Audit Log"
        style={{ padding: 20 }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="auto"
        footer={null}
      >
        <div className="">
          {isModalLoading ? (
            <LoadingScreen />
          ) : (
            <Table<AuditLog>
              dataSource={auditLog?.data}
              columns={auditCols}
              scroll={{ x: 1500, y: 500 }}
              pagination={false}
            />
          )}
        </div>
      </Modal>
      {selectedRecord && isDownloading && (
        <DownloadLogs record={selectedRecord} onDownload={handleDownloadComplete} />
      )}
    </>
  );
};

export default PendingReceiptList;
